import * as ROUTES from 'Routes'
import { ROOT_URL } from 'gatsby-env-variables'
import { navigate } from 'gatsby'
import Text from 'components/Text'
import Button from 'components/Button'
import router from 'utils/router'
import analytics from '@mobi/libraries/analytics'
import './LandingFeatures.scss'
import { handlePerformanceMark } from 'utils/trackings/newRelicEvents'
import listItems from './listItems'

const LandingFeatures = () => {
  return (
    <div className="landing-features">
      <Text h2 className="features-top-part">
        Veja como é fácil renegociar e limpar o nome:
      </Text>
      <div className="features-middle-part">
        {listItems.map(({ id, text }) => (
          <div className="item" key={id}>
            <Text p className="item-number" aria-hidden="true">
              {id}.
            </Text>
            <Text
              p
              className="item-text"
              dangerouslySetInnerHTML={{
                __html: `<span class="sr-only">${id}:</span> ${text}`,
              }}
            />
          </div>
        ))}
      </div>
      <div className="features-bottom-part">
        <Button
          className="button"
          onClick={() => {
            analytics.track('segmentButtonClick', {
              name: 'ConsultarCpf:Features',
              id: '62229237-1f4b-461b-b8d0-fe96431ecc0c',
            })
            handlePerformanceMark(ROUTES.register.pageName)
            navigate(ROUTES.register.path, {
              state: {
                source_url: location.href,
                mp_uuid: router.getQueryString('mp_uuid'),
              },
            })
          }}
          data-unique="62229237-1f4b-461b-b8d0-fe96431ecc0c"
          data-tracking-location="lp"
          data-tracking-position="lp-cta"
          data-tracking-actionoutcome="check_cpf"
          data-tracking-element="button"
          data-tracking-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
        >
          consulte suas dívidas
        </Button>
      </div>
    </div>
  )
}

export default LandingFeatures
